<template>
  <div>
    <custom-filter
      :fields="filterFields"
      @onFilter="onFilter"
      @onClear="onClearFilter"
    />
    <b-card title="Push Config">
      <b-button
        size="sm"
        variant="outline-success"
        :to="{ name: 'admin-push-config-register' }"
      >
        Adicionar
      </b-button>
      <b-button size="sm" variant="outline-secondary" @click="reportData">
        Relatório
      </b-button>
      <custom-table
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="true"
        :hasDeleteButton="false"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onEdit="onEdit"
        @onDelete="onDelete"
      />
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard } from "bootstrap-vue";
import CustomTable from "@/views/custom/table/CustomTable.vue";
import pushConfigService from "@/providers/pushConfigService";
import AppConstants from "@/appConstants";
import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import dropdownService from "@/providers/dropdownService";
import messageDialogHelper from "@/helpers/message-dialog-helper";

export default {
  components: {
    BButton,
    BCard,
    CustomTable,
    CustomFilter,
  },
  data() {
    return {
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filterFields: [
        {
          id: "filter-origin",
          placeholder: "Origem",
          type: "list",
          inputType: "",
          model: "origin",
          list: "filter-list-origin",
          array: [],
        },
      ],
      filter: {},
      tableLoading: true,
      fields: [
        { key: "app_id", label: "APP ID" },
        { key: "api_token", label: "API TOKEN" },
        { key: "origin", label: "Origem", type: "object" },
        { key: "dt_create", label: "Criação", type: "date" },
        { key: "active", label: "Habilitado", type: "boolean" },
        { key: "action_buttons", label: "Ações" },
      ],
      origins: [],
    };
  },
  mounted() {
    this.loadDataFilter();
    this.loadData();
  },
  computed: {
    searchParams() {
      const params = new URLSearchParams();
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.filter.origin) {
        params.append("origin", this.filter.origin.id);
      }
      return params;
    },
  },
  methods: {
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      pushConfigService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "pushConfig.csv");
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      this.filter = data;
      // console.log('OnFilter: ', this.filter);
      this.loadData();
    },
    onClearFilter() {
      this.filter = {};
      this.loadData();
    },
    loadDataFilter() {
      dropdownService
        .getAllOrigin(new URLSearchParams())
        .then((res) => {
          this.origins = res;
          this.filterFields[
            this.filterFields.findIndex((item) => item.id == "filter-origin")
          ].array = this.origins;
        })
        .catch((err) => console.log(err));
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_PUSHCONFIG_REGISTER}/${data._id}`
      );
    },
    onDelete(data) {
      // console.log(data);
      const params = new URLSearchParams();
      params.append("id", data._id);
      pushConfigService
        .deleteTag(params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(() => {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      this.tableLoading = true;
      pushConfigService
        .getAllPushConfig(this.searchParams)
        .then((res) => {
          this.tableLoading = false;
          // console.log(res);
          this.data = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style>
</style>